import { Injectable, inject } from '@angular/core';
import { HttpService } from './http.service';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class BankService {
    private http = inject(HttpService);
    private authService = inject(AuthService);


    registerWallet(client: any, form: any) {
        return this.http.save(
            "/bank/lemonway/wallet",
            { client_uniq: client.uniq, form: form },
            "",
            "",
            "",
            "ADMIN"
        );
    }

    updateWallet(client: any, form: any) {
        const form2 = this.getFormUpdateWallet(form);
        return this.http.save(
            "/bank/lemonway/wallet/update",
            { client_uniq: client.uniq, form: form2, form_save: form },
            "",
            "",
            "",
            "ADMIN"
        );
    }
    updateFrais(client: any, form: any) {
        return this.http.save(
            "/shop/updateFees/" + client.uniq,
            form[0],
            "",
            "",
            "",
            "ADMIN"
        );
    }
    registerBank(client: any, form: any, suid: any, siteUniq?: string) {
        // Transform contract_type from boolean to backend expected string enum
        const contractType = form.contract_type === true ? 'premium' : 'standard';

        // `...form` spreads the whole bank object, which used to carry the
        // Stripe Connect access token straight back to the server on every
        // save. The API no longer sends it, but stripping it here means a
        // stale cached object cannot resurrect one either — and `token` must
        // never be sent as an empty string, because that would ask the backend
        // to clear a live credential.
        const { token, has_secret, ...safeForm } = form ?? {};

        const payload: any = {
            client_uniq: client.uniq,
            site_uniq: siteUniq,
            name: form?.name || 'stripe', // Required field - default to 'stripe'
            ...safeForm,
            contract_type: contractType // Backend expects 'standard' or 'premium'
        };

        // Only ever sent when an admin actually typed a replacement.
        if (typeof token === 'string' && token.trim() !== '') {
            payload.token = token.trim();
        }

        return this.http.save(
            "/bank/bank",
            payload,
            "",
            suid,
            "",
            "ADMIN"
        );
    }

    getBank(client: any, siteUniq?: string) {
        if (!client || !client.uniq) {
            return this.http.get("/bank/bank/invalid", "ADMIN");  // Will return 404, but safer than undefined
        }
        let url = "/bank/bank/" + client.uniq;
        if (siteUniq) {
            url += "?site_uniq=" + siteUniq;
        }
        return this.http.get(url, "ADMIN");
    }

    getBanks() {
        return this.http.get("/bank/banks", "ADMIN");
    }

    getFormUpdateWallet(form: any) {
        return {
            wlLogin: form.wlLogin,
            wlPass: form.wlPass,
            language: form.language,
            version: form.version,
            walletIp: form.walletIp,
            walletUa: form.walletUa,
            wallet: form.wallet,
            newEmail: form.clientMail,
            newTitle: form.clientTitle,
            newFirstName: form.clientFirstName,
            newLastName: form.clientLastName,
            newStreet: form.street,
            newPostCode: form.postCode,
            newCity: form.city,
            newCtry: form.ctry,
            newIp: form.walletIp,
            newPhoneNumber: form.phoneNumber,
            newMobileNumber: form.mobileNumber,
            newBirthDate: form.birthdate,
            newIsCompany: form.isCompany,
            newCompanyName: form.companyName,
            newCompanyWebsite: form.companyWebsite,
            newCompanyDescription: form.companyDescription,
            newCompanyIdentificationNumber: form.companyIdentificationNumber,
            newIsDebtor: form.isDebtor,
            newNationality: form.nationality,
            newBirthcity: form.birthcity,
            newBirthcountry: form.birthcountry,
        };
    }

    getTransferLemonway() {
        return this.http.get("/bank/lemonway/transactions");
    }

    getAccountingStuart() {
        return this.http.get("/delivery/stuart/accounting");
    }

    getAccountingStripe(siteUniq?: string) {
        const url = siteUniq ? `/bank/stripe/fee?suid=${siteUniq}` : '/bank/stripe/fee';
        return this.http.get(url, this.authService.resolveShopRole());
    }

    replaceUniqClientFromUrl(url: any, uniq: string) {
        if (!url) return "";
        let isClient = false;

        // assuming url is array based on original code usage?
        // original code: url = url.map(...) then url.toString().replace...
        // But replacedUniqClientFromUrl is passed window.location.href.split('/')
        if (Array.isArray(url)) {
            const newUrl = url.map((part) => {
                if (part === "") {
                    return "";
                }
                if (part === "clients") {
                    isClient = true;
                } else if (isClient) {
                    part = uniq;
                    isClient = false;
                }
                return (part += "/");
            });
            return newUrl.join('').replace(/,/g, "");
        }
        return url;
    }

    createStripeAccount(client: any, tokens: any) {
        const url = this.replaceUniqClientFromUrl(
            window.location.href.split("/"),
            client.uniq
        );

        return this.http.save(
            "/shop/stripe/onboarding",
            {
                client_uniq: client.uniq,
                stripe_account_token: tokens.accountToken,
                stripe_person_token: tokens.personToken,
                return_url: url,
            },
            "",
            "",
            "",
            "ADMIN"
        );
    }

    getStripeExternalProvider() {
        const query = `query($type: String) {
      client {
        id
        external_providers(type: $type) {
          api_key
        }
      }
    }`;
        return this.http.gql_query(
            query,
            {
                type: "stripe_iban",
            },
            "CLIENT"
        );
    }

    getFrais(client: any) {
        return this.http.get("/shop/getFees/" + client.uniq, "ADMIN");
    }

    noFees(client: any, form: any) {
        // /shop/noFees sets with_fees_service = false; this used to post to
        // /shop/updateFees, which RE-ENABLES fees — the exact opposite
        return this.http.save(
            "/shop/noFees/" + client.uniq,
            form,
            "",
            "",
            "",
            "ADMIN"
        );
    }

    getClientStripeProvider(uniq: string) {
        const query = `query($uniq: String!) {
            client(uniq: $uniq) {
                id
                external_providers(type: "stripe_iban") {
                    api_key
                    provider_type
                }
            }
        }`;
        return this.http.gql_query(query, { uniq }, "ADMIN");
    }

    addStripeSource(clientId: any, sourceId: string) {
        return this.http.post('/shop/addStripeSource/' + clientId, { sourceId }, 'ADMIN');
    }

    // Stripe OAuth Connect methods
    //
    // Role comes from resolveShopRole(), not a hardcoded 'ADMIN'. With
    // 'ADMIN', a merchant session (PURE_CLIENT: `_token` set, `_adminToken`
    // empty) took the ADMIN branch in HttpService.getHeader, found no token
    // and sent NO Authorization header at all — the request 401'd, burned
    // three retries and logged the merchant out of their own Stripe settings.
    // getAccountingStripe below already did this correctly; the Connect
    // methods were missed. The backend enforces tenant ownership itself
    // (AuthorizesActors), so sending the merchant's own token is safe.
    //
    // `client_uniq` is only appended when present: the old unconditional
    // concatenation sent the literal `client_uniq=undefined` for a
    // site-scoped call.
    private stripeConnectQuery(clientUniq?: string, siteUniq?: string): string {
        const params = new URLSearchParams();
        if (clientUniq) {
            params.set('client_uniq', clientUniq);
        }
        if (siteUniq) {
            params.set('site_uniq', siteUniq);
        }
        return params.toString();
    }

    initiateStripeConnect(clientUniq: string, siteUniq?: string) {
        return this.http.get(
            '/bank/stripe/connect?' + this.stripeConnectQuery(clientUniq, siteUniq),
            this.authService.resolveShopRole()
        );
    }

    disconnectStripe(clientUniq: string, siteUniq?: string) {
        return this.http.delete(
            '/bank/stripe/disconnect?' + this.stripeConnectQuery(clientUniq, siteUniq),
            this.authService.resolveShopRole(),
            // HttpService.delete notifies by default, which produced a
            // "deleted successfully" toast alongside the caller's own
            // "disconnected successfully" one.
            false
        );
    }

    getStripeStatus(clientUniq: string, siteUniq?: string) {
        return this.http.get(
            '/bank/stripe/status?' + this.stripeConnectQuery(clientUniq, siteUniq),
            this.authService.resolveShopRole()
        );
    }
}
